export const formatCurrency = (cents, currency = 'USD') => {
  const amount = cents / 100;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
};

export const parseCurrency = (value) => {
  const cleanValue = value.toString().replace(/[^0-9.]/g, '');
  const amount = parseFloat(cleanValue) || 0;
  return Math.round(amount * 100);
};